module.exports = __webpack_public_path__ + "img/default-chess-horse.4c9eae39.svg";